'use strict';

module.exports = require('../5/CheckObjectCoercible');



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/2023/RequireObjectCoercible.js
 ** module id = 147
 ** module chunks = 0
 **/